export default __webpack_public_path__ + "static/media/rotate-right.6f586206.svg";